import React from 'react';
import { Navigate } from 'react-router-dom';

import { buildPath } from '../utils/common';
import { privateRoutePaths } from './private.route.config';
import { useAuth } from '../AuthProvider';
import roles from '@/constant/roles.config';

const PublicRouteWrapper = ({ element, restricted }) => {
    const { token, user, isPreKYCUser, isDemoUser, isEndUser, isViewer, isOpUser, isAdmin } = useAuth();

    const getPrefix = () => {
        if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
        if (user && isDemoUser) return roles.DEMO.prefix;
        if (user && isEndUser) return roles.END_USER.prefix;
        if (user && isViewer) return roles.VIEWER.prefix;
        if (user && isOpUser) return roles.OPERATION_USER.prefix;
        if (user && isAdmin) return roles.ADMIN.prefix;
        return roles.SUPER_ADMIN.prefix;
    };

    // If route requires permissions but user doesn't have them
    if (token && restricted && user) {
        if (user.role_slug.slug === "VIEWER" || user.role_slug.slug === "OPERATION_USER" || user.role_slug.slug === roles.INQ_MANAGER.slug_name) {
            return <Navigate to={`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`} replace />;
        }
        if (user.role_slug.slug === "DEMO") {
            return <Navigate to={`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`} replace />;
        }

        if (user.role_slug.slug === "PRE_KYC") {
            return <Navigate to={`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: user.member_id })}`} replace />;
        }

        if (user.role_slug.slug === "END_USER") {
            return <Navigate to={`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`} replace />;
        }

        if (user.role_slug.slug === "SUP_ADM" || user.role_slug.slug === "ADMIN") {
            return <Navigate to={`/${getPrefix()}${privateRoutePaths.MANAGE_LEADS.path}`} replace />;
        }
    }

    return element;
};
export default PublicRouteWrapper;
